import { useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import RouteGuard from "./RouteGuard";
// import Footer from './Footer';
import Cookies from "universal-cookie";
import ActiveOrder from "../Dynamic/ActiveOrder";
import GroupMessageBox from "../Dynamic/GroupMessageBox";
import InventoryCSV from "../Dynamic/InventoryCSV";
import MyCart from "../Dynamic/MyCart";
import MyInventories from "../Dynamic/MyInventories";
import OfferRequest from "../Dynamic/OfferRequest";
import OrderDetail from "../Dynamic/OrderDetail";
import OrderSuccess from "../Dynamic/OrderSuccess";
import ProductDetail from "../Dynamic/ProductDetail";
import SampleRequest from "../Dynamic/SampleRequest";
import Typesense from "../Dynamic/Typesense";
import UserList from "../Dynamic/UserList";
import ViewCSV from "../Dynamic/ViewCSV";
import ViewOfferRequest from "../Dynamic/ViewOfferRequest";
import ViewSampleRequest from "../Dynamic/ViewSampleRequest";
import ViewSellRequest from "../Dynamic/ViewSellRequest";
import CompanyDashboard from "../Dynamic/CompanyDashboard";
import Footer from "./Footer";
import UserHeader from "./UserHeader";
import EditBarrel from "../Dynamic/EditBarrel";
import AddCompanyOrUser from "../Dynamic/AddCompanyOrUser";
import AddSupportRequest from "../Dynamic/AddSupportRequest";
import AllNotification from "../Dynamic/AllNotification";
import CompareInventory from "../Dynamic/CompareInventory";
import CustomerSupport from "../Dynamic/CustomerSupport";
import EmptyCart from "../Dynamic/EmptyCart";
import InventoryEmpty from "../Dynamic/InventoryEmpty";
import InventoryListing from "../Dynamic/InventoryListing";
import MyRequests from "../Dynamic/MyRequests";
import SupportRequest from "../Dynamic/SupportRequest";
import ViewInventoryListingDetails from "../Dynamic/ViewInventoryListingDetails";
import ViewSoldInventoryListingDetails from "../Dynamic/ViewSoldInventoryListingDetails";
import ViewSupportRequest from "../Dynamic/ViewSupportRequest";
import ViewOrEditProfile from "../Static/Profile/ViewOrEditProfile";
import UATbelt from "./UATbelt";
import { CommonService } from "../../Service/CommonService";
import BarrelMarketValue from "../Dynamic/BarrelMarketValue";
import MarketValueHistory from "../Dynamic/MarketValueHistory";
import BarrelMarketValueChartView from "../Dynamic/BarrelMarketValueChartView";
import CompaniesContractListing from "../Dynamic/CompaniesContractListing";
import ViewContract from "../Dynamic/ViewContract";
import ViewContractPricingDetails from "../Dynamic/ViewContractPricingDetails";
import BarrelOwnerListing from "../Dynamic/BarrelOwnersListing";
import AddOwner from "../Dynamic/AddOwner";
import SellRequestHistory from "../Dynamic/SellRequestEditHistory";
import ProofHistory from "../Dynamic/ProofHistory";
import ValuationHistory from "../Dynamic/ValuationHistory";
import WantedToBuyTypesense from "../Dynamic/WantedToBuyTypesense";
import WantedToBuyProductDetail from "../Dynamic/WantedToBuyProductDetail";
import ContainerDetail from "../Dynamic/ContainerDetail";
import ContainerHistory from "../Dynamic/ContainerHistory";
import EditLotDetails from "../Dynamic/EditLotDetails";
import OwnershipTransferListing from "../Dynamic/OwnershipTransferListing";

const UserLayout = () => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const history = useHistory();

  useEffect(() => {
    (window as any).routeChangeCount = ((window as any).routeChangeCount || 0) + 1;
    const unlisten = history.listen(() => {
      (window as any).routeChangeCount = ((window as any).routeChangeCount || 0) + 1;
    });
    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(() => {
    const fetchUserRole = () => {
      const cookies = new Cookies();
      const role = cookies.get("userRole");
      setUserRole(role);
    };

    fetchUserRole();
  }, []); // Empty dependency array ensures this effect runs only once

  if (userRole === null) {
    // Render loading indicator while fetching user role
    return <div>Loading...</div>;
  }

  const route = (route: string) => {
    history.push(route);
  };

  return (
    <div>
      <UATbelt />
      <UserHeader />
      <Switch>
        <Route exact path="/user/my-profile/:id">
          <ViewOrEditProfile />
        </Route>
        <Route exact path="/user/my-requests">
          <MyRequests />
        </Route>
        <RouteGuard exact path="/user/edit-barrel/:id">
          <EditBarrel />
        </RouteGuard>
        <RouteGuard exact path="/user/proof-history/:id">
          <ProofHistory />
        </RouteGuard>
        <RouteGuard exact path="/user/valuation-history/:id">
          <ValuationHistory />
        </RouteGuard>
        <Route exact path="/user/my-warehouse/inventory">
          <MyInventories />
        </Route>
        <Route exact path="/user/my-warehouse/available-for-sell">
          <MyInventories />
        </Route>
        <Route exact path="/user/my-warehouse/not-available-for-sell">
          <MyInventories />
        </Route>
        <Route exact path="/user/my-warehouse/marketplace-listings">
          <InventoryListing />
        </Route>
        <Route exact path="/user/my-warehouse/ownership-transfer-listings">
          <OwnershipTransferListing />
        </Route>
        <Route exact path="/user/view-inventory-listing-details/:id">
          <ViewInventoryListingDetails />
        </Route>
        <Route exact path="/user/view-sold-inventory-listing-details/:id">
          <ViewSoldInventoryListingDetails />
        </Route>
        <Route exact path="/user/inventory-change-requests">
          <MyInventories />
        </Route>
        <Route exact path="/user/compare-inventory/:id">
          <CompareInventory />
        </Route>
        <Route exact path="/user/my-warehouse">
          <CompanyDashboard />
        </Route>
        <Route exact path="/user/inventories">
          <Typesense />
        </Route>
        <Route exact path="/user/inventory-sell-requests">
          <InventoryCSV />
        </Route>
        <Route exact path="/user/product-details/:id">
          <ProductDetail />
        </Route>
        <Route exact path="/user/my-cart">
          <MyCart />
        </Route>
        <Route exact path="/user/view-csv/:id">
          <ViewCSV />
        </Route>
        <Route exact path="/user/view-sell-request/:id">
          <ViewSellRequest />
        </Route>
        <Route exact path="/user/view-edit-sell-request-history/:requestId/:historyId">
          <SellRequestHistory />
        </Route>
        <Route exact path="/user/order-detail/:id">
          <OrderDetail />
        </Route>
        <Route exact path="/user/view-as-owner/order-detail/:id">
          <OrderDetail />
        </Route>
        <Route exact path="/user/view-as-buyer/order-detail/:id">
          <OrderDetail />
        </Route>
        <Route exact path="/user/active-order">
          <ActiveOrder />
        </Route>
        <Route exact path="/user/my-warehouse/active-order">
          <ActiveOrder />
        </Route>
        <Route exact path="/user/view-as-owner/active-order">
          <ActiveOrder />
        </Route>
        <Route exact path="/user/view-as-buyer/active-order">
          <ActiveOrder />
        </Route>
        <Route exact path="/user/sample-request">
          <SampleRequest />
        </Route>
        <Route exact path="/user/view-sample-request/:id">
          <ViewSampleRequest />
        </Route>
        <Route exact path="/user/my-warehouse/sample-request">
          <SampleRequest />
        </Route>
        <Route exact path="/user/offer-request">
          <OfferRequest />
        </Route>
        <Route exact path="/user/view-offer-request/:id">
          <ViewOfferRequest />
        </Route>
        <Route exact path="/user/my-warehouse/offer-request">
          <OfferRequest />
        </Route>
        <Route exact path="/user/wish-list">
          <Typesense />
        </Route>
        <Route exact path="/user/messages">
          <GroupMessageBox />
        </Route>
        <Route exact path="/user/order-success">
          <OrderSuccess />
        </Route>
        <Route exact path="/user/empty-cart">
          <EmptyCart />
        </Route>
        <Route exact path="/user/user-list">
          <UserList />
        </Route>
        <Route exact path="/user/my-warehouse/user-list/:id">
          <UserList />
        </Route>
        <Route exact path="/user/user-detail/:id">
          <ViewOrEditProfile />
        </Route>
        <Route exact path="/user/inventory-list">
          <InventoryEmpty />
        </Route>
        <Route exact path="/user/add-user">
          <AddCompanyOrUser type={"user"} />
        </Route>
        <Route exact path="/user/view-as-buyer">
          <CompanyDashboard />
        </Route>
        <Route exact path="/user/view-as-owner">
          <CompanyDashboard />
        </Route>
        <Route exact path="/user/customer-support">
          <CustomerSupport/>
        </Route>
        <Route exact path="/user/customer-service">
          <SupportRequest />
        </Route>
        <Route exact path="/user/add-customer-service-request">
          <AddSupportRequest />
        </Route>
        <Route exact path="/user/view-customer-service-request/:id">
          <ViewSupportRequest />
        </Route>
        <Route exact path="/user/edit-customer-service-request/:id">
          <AddSupportRequest />
        </Route>
        <Route exact path="/user/all-notification">
          <AllNotification/>
        </Route>
        <Route exact path="/user/barrel-market-value">
          <BarrelMarketValue/>
        </Route>
        <Route exact path="/user/my-warehouse/barrel-market-value">
          <BarrelMarketValue/>
        </Route>
        <Route exact path="/user/market-value-history/:id/:lotId">
          <MarketValueHistory/>
        </Route>
        <Route exact path="/user/barrel-market-value-chart-view/:lotId">
          <BarrelMarketValueChartView/>
        </Route>

        <Route exact path = "/user/view-contract">
          <CompaniesContractListing/>
        </Route>

        <Route exact path = "/user/view-contract/:id">
          <ViewContract/>
        </Route>

        <Route exact path = "/user/contract-pricing-details/:id">
          <ViewContractPricingDetails/>
        </Route>

        <Route exact path = "/user/barrel-owners">
          <BarrelOwnerListing/>
        </Route>

        <Route exact path = "/user/add-owner">
          <AddOwner/>
        </Route>

        <Route exact path = "/user/update-owner/:id">
          <AddOwner/>
        </Route>

        <Route exact path="/user/my-warehouse/service-requests">
          <CompanyDashboard />
        </Route>

        <Route exact path="/user/wanted-to-buy">
          <WantedToBuyTypesense />
        </Route>

        <Route exact path="/user/wanted-to-buy-product-details/:id">
          <WantedToBuyProductDetail />
        </Route>

        <RouteGuard exact path="/user/container-detail/:id">
          <ContainerDetail />
        </RouteGuard>
        <RouteGuard exact path="/user/container-history-detail/:id">
          <ContainerHistory/>
        </RouteGuard>

        <RouteGuard exact path="/user/edit-lot-details/:id">
          <EditLotDetails />
        </RouteGuard>

        <Route path="*">
            <Redirect to="/user/inventories" />
        </Route>
      </Switch>
      {<Footer />}
    </div>
  );
};

export default UserLayout;